const nodeTypes = {
  assembly: '1',
  entityType: '2',
  mnemonic: '3'
};
export default nodeTypes;
